import my_contest_config from "./my_contest_config.json";
import { Sports, SportsIDs } from "./Sports";
export { my_contest_config, Sports, SportsIDs };
